import { IFilterAllData, ListOfKeysFilterAllData } from 'src/typings/filter';

export function countRatingBySection(list: IFilterAllData[], houseId?: string): Record<string, number> {
  const filtered = houseId ? list.filter((item: IFilterAllData) => item[ListOfKeysFilterAllData.houseId].includes(houseId)) : list;
  return filtered.reduce((acc, i) => {
    const k = i[ListOfKeysFilterAllData.section];
    if (!k || i[ListOfKeysFilterAllData.placementStatusShowInModule] === 'hide') return acc;
    acc[k] = (acc[k] ?? 0) + 1;
    return acc;
  }, {} as Record<string, number>);
}

export function countRatingByFloor(list: IFilterAllData[], houseId?: string): Record<string, number> {
  const filtered = houseId ? list.filter((item: IFilterAllData) => item[ListOfKeysFilterAllData.houseId].includes(houseId)) : list;
  return filtered.reduce((acc, i) => {
    const k = i[ListOfKeysFilterAllData.floorIds][0];
    if (!k) return acc;
    acc[k] = (acc[k] ?? 0) + 1;
    return acc;
  }, {} as Record<string, number>);
}

export function getSectionIdByMaxRating(obj: Record<string, number>): string | null {
  const entries = Object.entries(obj);
  if (!entries.length) return null;
  return entries.reduce(([mk, mv], [k, v]) => (v > mv ? [k, v] : [mk, mv]))[0];
}
